module.exports = __webpack_public_path__ + "static/media/cola.a9d15cd8.jpg";